import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetServiceModel } from "@factory/model/query-model-service";
import { serviceFormDefault } from "./form.default";
import { ServiceFormSchema } from "./form.rule";

export const useFormDefaultService = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetServiceModel | undefined) => {
    return !cachedValue
      ? serviceFormDefault
      : ({
          name: cachedValue.name,
          description: cachedValue.description,
          amount: cachedValue.amount,
          duration: cachedValue.duration,
          isOpenTime: Boolean(cachedValue.is_open_time),
          upgrade: cachedValue.upgrade,
          isActive: Boolean(cachedValue.is_active),
          isSubscription: Boolean(cachedValue.is_subscription),
          days: cachedValue.days,
          tenant: cachedValue.tenant,
        } as ServiceFormSchema);
  };

  return {
    getDefault,
  };
};
